import { getHomePath } from "@shared/common/node/condition";
import type { ExternalSiteCheckRule } from "../../types";
import { IMWEB_PAGE, SITE_TYPE } from "./const";

const imweb: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target, siteUrl }) {
    if (target.value === "HOME" && url.pathname === getHomePath(siteUrl)) {
      return true;
    }

    if (
      target.value === IMWEB_PAGE.LOGIN.target &&
      url.pathname === IMWEB_PAGE.LOGIN.url
    ) {
      return true;
    }

    if (
      target.value === IMWEB_PAGE.SIGNUP.target &&
      url.pathname === IMWEB_PAGE.SIGNUP.url
    ) {
      return true;
    }

    if (
      target.value === IMWEB_PAGE.MY_PAGE.target &&
      url.pathname === IMWEB_PAGE.MY_PAGE.url
    ) {
      return true;
    }

    if (
      target.value === IMWEB_PAGE.CART.target &&
      url.pathname === IMWEB_PAGE.CART.url
    ) {
      return true;
    }

    return false;
  },
};

export default imweb;
